import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('portaliLanding');
export const actions = helper.createActions('portaliLanding', actionTypes);